<template>
  <div style="width: 100%;">
    <el-header style="margin: 15px" >
      <breadcrumb></breadcrumb>
    </el-header>

      <el-main style="overflow-x: hidden;">
        <el-form ref="form" label-width="150px" >
          <el-row>
            <el-col :span="12">
              <el-form-item label='Model'>
                <el-select v-model="docModel" :placeholder="$t('msg.pleaseSelect')" clearable >
                  <el-option v-for="item in modelOpts"  :key="item"  :label="item" :value="item"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label='Type'>
                <el-select v-model="docType" :placeholder="$t('msg.pleaseSelect')" clearable >
                  <el-option v-for="item in typeOpts"  :key="item"  :label="item" :value="item"></el-option>
                </el-select>
              </el-form-item>
            </el-col>                        
          </el-row>   
          <el-row>
            <el-col :span="24" style="text-align:center">
              <el-button type="primary" @click="search"  size="small">{{$t('button.search')}}</el-button>
            </el-col>             
          </el-row>   
        </el-form>
        <el-row>  
          <!--Table ref="table1" :tableData="tableData" :linkAction="linkAction"/--> 
                <Table ref="tableList" :tableData.sync="tableData" :showSearch="true" :showEdit="true" :showExport="true" :showImport="false" :showEditButton="true"  
             @sync-delete="deleteDoc" @sync-save="saveDoc" @sync-file-status="saveFileSuccess" @reload-data-by-sort="reloadDataBySort"/> 
        </el-row>
        
    </el-main>
  </div>
</template>

<script>
//import Table from '../components/FuzzySearchTable'
import Table from '../components/EditableTableWithFile'
import Breadcrumb from '../components/Breadcrumb'
import { apiFindDocByCondition, apiFindDocModel, apiFindDocType, apiSaveDoc, apiDeleteDocById } from "../../utils/api.js";
import authHeader from "../../services/auth-header";
import CommonUtil from "../../utils/commonUtil.js";

  
export default {
  name: 'documentVersion',
  data() {    
    return { 
      addDataSuccess: false,   
      docModel: '',
      modelOpts:[],
      docType: '',
      typeOpts:[],
      sortColumn:'',
      sortType:'',
      tableData: {
        sel: null,
        columns: [
          { field: "releaseDate", title: 'Release Date', width: 140, type:"date", align:'center', required:true },
          { field: "model", title: 'Model' , width: 130, type:'select' },
          { field: "name", title: 'Type' , width: 180, type:'select', required:true   },
          { field: "modelRel", title: 'Model Rel', type:'select' , width: 115 },
          { field: "docName", title: this.$i18n.t('field.documentName'), link:true, type:"file"}
        ],
        uploadType:"document" ,
        originalTableData:[],
        data: [],
        pagesize: 10,
        currentPage: 1,
        tableId:'documentTable',
        exportName: this.$i18n.t('menu.documentVersion'),
        showCreate:true
      }    
    };
  }, 
  components: {
    Breadcrumb,
    Table
  },
  created(){
      this.tableData.columns.forEach((item) => {
        if(item.field == 'name'){
         apiFindDocType({ headers: authHeader()}).then((response) => { 
            item.selectObj = [];
            response.data.forEach((item2, index) => {   
              item.selectObj.push({ value: item2, label: item2 });
            });
          }).catch((err) => {
            console.log(err);
          });
        }
        if(item.field == 'model'){
          //item.selectObj = this.swfwOpts;
          apiFindDocModel({ headers: authHeader()}).then((response) => { 
            item.selectObj = [];
            response.data.forEach((item2, index) => {   
              item.selectObj.push({ value: item2, label: item2 });
            });
          }).catch((err) => {
            console.log(err);
          });
        }

        if(item.field == 'modelRel'){
          item.selectObj = [{value:'Y',label:'Y'},{value:'',label:'N'}];
        }

      });
         
  },
  mounted() {  
    apiFindDocModel({ headers: authHeader()}).then((response) => { 
      this.modelOpts = [];
      if(response.status== 200 && response.data != null && response.data.length > 0){
          this.modelOpts = response.data;
      }
    }).catch((err) => {
      console.log(err);
    });

    apiFindDocType({ headers: authHeader()}).then((response) => { 
      this.typeOpts = [];
      if(response.status== 200 && response.data != null && response.data.length > 0){
          this.typeOpts = response.data;
      }
    }).catch((err) => {
      console.log(err);
    });
    this.findData()
   
  },
  methods: {
    findData(){
      this.tableData.data = [];
      this.tableData.originalTableData =  [];        
      apiFindDocByCondition({ headers: authHeader(), model: this.docModel, name: this.docType, sortColumn: this.sortColumn, sortType:this.sortType}).then((response) => { 
     
           response.data.forEach((item, index) => { 
             item.releaseDate = CommonUtil.dateFormatDate(new Date(item.releaseDate )); 
           //debugger;
           //item.fileName = item.version;
           //item.fileName.linkAction.afileName = item.fileName;
           // item.version = download(item.name,item.version);
             //if(item.title =='File') item.link = true;
          });  
          this.tableData.data = response.data;  
          this.tableData.originalTableData =  this.tableData.data;  
          //this.$refs.table1.$refs.filterTable.doLayout();

      }).catch((err) => {
        console.log(err);
      });
    },
    search() {
      this.findData();
    },
    saveDoc(data, newFileData){
    debugger
      if(data.length == null){
        data = [data];
      }

      apiSaveDoc({  headers: authHeader(), docs : data}).then((response) => {                    
        if(response.status == 200){
           this.$message.success({message: this.$i18n.t('msg.saveSuccess'), duration: 800});
          //debugger
          if(typeof newFileData != "undefined") {
          newFileData.docId = response.data;
          if(newFileData.docId!='undefined' && newFileData.docId!=''){
            this.addDataSuccess = true;
            this.$refs.tableList.addFile(newFileData);
          }else{
            this.$message.success({message: this.$i18n.t('msg.saveSuccess'), duration: 800});
            //this.findData();
          }
          }
          this.findData();
        }else{          
          this.$message.error({message: this.$i18n.t('msg.saveFail'), duration: 1000});
        }       

        
      }).catch((err) => {
        // if(err.response.data.message != null && err.response.data.message != ''){
        //   this.$message.error({message:err.response.data.message, duration: 1000});
        // }else{
          this.$message.error({message: this.$i18n.t('msg.saveFail'), duration: 1000});
        // }        
        console.log(err);
      });
    },    
    deleteDoc(data){           
      apiDeleteDocById({  headers: authHeader(), deleteId : data.id}).then((response) => {               
        if(response.status == 200){
          this.$message.success({message: this.$i18n.t('msg.deleteSuccess'), duration: 800});
        }else{
          this.$message.error({message: this.$i18n.t('msg.deleteFail'), duration: 800});
        }
      }).catch((err) => {
        console.log(err);
      });
    },
    saveFileSuccess(fileStatus){
      if(this.addDataSuccess && fileStatus){
        this.$message.success({message: this.$i18n.t('msg.saveSuccess'), duration: 800});
        this.findData();
      }else{
        this.$message.error({message: this.$i18n.t('msg.saveFail'), duration: 1000});
      }
    },
    reloadDataBySort(sortColumn, sortType){
      this.sortColumn = sortColumn;
      this.sortType = sortType;
      debugger
      this.findData()
    } 
  }
};
</script>
